module.exports = __webpack_public_path__ + "img/7.6eaa3354.svg";